import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class ArgumentOperandElementInfoImpl {
  constructor(operandName, expArgumentOperand, elementOption) {
    _defineProperty(this, "_operandName", void 0);
    _defineProperty(this, "_expArgumentOperand", void 0);
    _defineProperty(this, "_elementOption", void 0);
    this._operandName = operandName;
    this._expArgumentOperand = expArgumentOperand;
    this._elementOption = elementOption;
  }
  get operandName() {
    return this._operandName;
  }
  get expArgumentOperand() {
    return this._expArgumentOperand;
  }
  get elementOption() {
    return this._elementOption;
  }
}
//# sourceMappingURL=ArgumentOperandElementInfoImpl.js.map
